"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BFF_GATEWAY_TEST_URL = exports.BFF_GATEWAY_PRODUCTION_URL = exports.AuthorizeErrors = void 0;
var interfaces_1 = require("../common/interfaces");
exports.AuthorizeErrors = {
    MISSING_API_KEY: {
        code: 'CSDK-001',
        message: 'Api key is required',
        type: interfaces_1.ErrorType.AUTHORIZATION,
    },
    AUTHORIZE_FAILURE: {
        code: 'CSDK-002',
        message: 'Authorization Failure',
        type: interfaces_1.ErrorType.AUTHORIZATION,
    },
    UNKNOWN_FAILURE: {
        code: 'CSDK-000',
        message: 'Unknown api failure',
        type: interfaces_1.ErrorType.SERVER,
    },
    BAD_REQUEST: {
        code: 'CSDK-003',
        message: 'Bad Request',
        type: interfaces_1.ErrorType.SERVER,
    },
};
exports.BFF_GATEWAY_PRODUCTION_URL = 'https://gateway.chegg.com/';
exports.BFF_GATEWAY_TEST_URL = 'https://gateway.test.cheggnet.com/';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/authorize/constants.js
// module id = 623
// module chunks = 11